define(function (require) {
    var jQuery = require('jquery');

    return (function ($) {

        var methods = {
            init: function (options) {
                return this.each(function () {
                    var $this = $(this);

                    // select2
                    $this.find('.select2').select2({
                        language: {
                            // inputTooShort: function () { return 'Введите 1 или более букв' },
                            noResults: function () {
                                return 'Ничего не найдено'
                            }
                        }
                    });

                    // Tooltips
                    $this.find('[data-toggle="tooltip"]').tooltip({
                            container: 'body',
                            trigger: 'hover',
                        });
                    // $this.find('*[title]').tooltip();

                    // Clockpicker
                    $this.find('.clockpicker').clockpicker({
                        placement: 'bottom',
                        align: 'left',
                        autoclose: true,
                        'default': 'now'
                    });

                    // Tabs
                    $this.find('.nav.nav-tabs a').on('click', function (event) {
                        event.preventDefault();
                        $(this).tab('show');
                    });
                    $this.find('.nav.nav-pills a').on('click', function (event) {
                        event.preventDefault();
                        $(this).tab('show');
                    });

                    // Scrollbar
                    $this.find('.scrollbar-macosx').scrollbar();

                    //Popover
                    // $this.find('[data-toggle="popover"]').popover();

                    // Player
                    //audiojs.events.ready(function () {
                    //    var as = audiojs.createAll();
                    //});
                });
            }
        };

        $.fn.lptSetter = function (method) {
            if (methods[method]) {
                return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
            } else if (typeof method === 'object' || !method) {
                return methods.init.apply(this, arguments);
            } else {
                $.error('Метод с именем ' + method + ' не существует для jQuery.lptSetter');
            }
        };

    })(jQuery);
});
